const mobileNav = document.querySelector(".hamburger");
const navbar = document.querySelector(".menubar");
const menuItems = document.querySelectorAll(".menubar li");
const productReviewwrap = document.querySelector(".product_and_review_wrap");
const products_menu = document.querySelector("products_menu");
const overlaybg = document.querySelector(".overlay-menu-active");
const cartCount = document.querySelector(".cart-text");
const cartIcon = document.querySelector(".cart-icon");
const menuBottle = document.querySelector(".bottle-container");
const cartBorder = document.querySelector(".cart");
const carttextMobile = document.querySelector(".cart-text-mobile");
const menuText = document.querySelector(".hamburger-text");

//catch path
function getPagePath() {
  return window.location.pathname;
}
const currentPath = getPagePath();
const blockToggleColorByPath = [
  "/",
  "/pages/cocktails",
  "/pages/recipes",
  "/pages/valentines-landing",
];

const toggleNav = () => {
  const fadeOutSpeed = 50;
  const fadeInDelay = 500;

  // Get the current scroll position
  const forTogglecurrentScrollPosition = window.scrollY;

  if (navbar.classList.contains("active")) {
    prodctreviewWrap.classList.add(
      "custome_toggle",
      "remove-fade-products-review"
    );

    // Fade out menu items
    menuItems.forEach((item, index) => {
      setTimeout(() => {
        productReviewwrap.classList.add("remove-fade-products-review");

        item.classList.replace("fade-in", "fade-out");
      }, index * fadeOutSpeed);
    });

    setTimeout(() => {
      navbar.classList.remove("active");
      // Set colors to white after menu deactivates
      // Check if current scroll position is less than 700

      if (forTogglecurrentScrollPosition < 700) {
        if (blockToggleColorByPath.includes(currentPath)) {
          cartIcon.classList.add("menu-bottle-white");
          menuBottle.classList.add("menu-bottle-white");
          // cartBorder.style.borderRight = "1px solid white";
          cartCount.classList.remove("colored-title");
          carttextMobile.classList.remove("colored-title");
          menuText.classList.remove("colored-title");
        }
      }

      mobileNav.classList.remove("hamburger-active");
      navbar.classList.remove(
        "hide-main-menu",
        "sub_menu_active",
        "align-start"
      );
      productsMenu.classList.remove("active-sub");
      mainMenu.classList.remove("main_menu_toggle");
      reviewWrap.style.display = "none";
      prodctreviewWrap.classList.remove("product_review_transition");
      overlaybg.classList.remove("overlay-menu");
    }, menuItems.length * fadeOutSpeed + fadeInDelay);
  } else {
    menuItems.forEach((item, index) => {
      setTimeout(() => {
        productReviewwrap.classList.remove("remove-fade-products-review");
        item.classList.add("fade-in");
        item.classList.remove("fade-out");
        overlaybg.classList.add("overlay-menu");
      }, fadeInDelay + index * 100);
    });

    navbar.classList.add("active");
    navbar.style.opacity = "1";

    // Set cart and other elements to colored when active

    cartIcon.classList.remove("menu-bottle-white");
    menuBottle.classList.remove("menu-bottle-white");
    // cartBorder.style.borderRight = "1px solid #2B2B2B";
    cartCount.classList.add("colored-title");
    carttextMobile.classList.add("colored-title");
    mobileNav.classList.add("hamburger-active");
    menuText.classList.add("colored-title");
  }
};

document.addEventListener("click", (event) => {
  const isClickInsideNav = navbar.contains(event.target);
  const isClickOnHamburger = mobileNav.contains(event.target);

  if (!isClickInsideNav && !isClickOnHamburger) {
    if (navbar.classList.contains("active")) {
      toggleNav();
    }
  }
});

// Function to toggle the navigation bar
const toggleNavOptional = (event) => {
  event.stopPropagation();
  toggleNav(); // Calls the existing toggle function
};

// Add click event listeners to both elements
if (mobileNav) {
  mobileNav.addEventListener("click", toggleNavOptional);
}

if (menuText) {
  menuText.addEventListener("click", toggleNavOptional);
}

// Handle products toggle logic
const productsToggle = document.getElementById("productsToggle");
const goBackBtn = document.querySelector(".go-back");
const productsMenu = document.querySelector(".products_menu");
const reviewWrap = document.querySelector(".review_wrap");
const mainMenu = document.querySelector(".main_menu");
const logoHide = document.getElementById("main_logo");
const prodctreviewWrap = document.querySelector(".product_and_review_wrap");

const prodctToggle = document.querySelector(".product_toggle");
const headerTitle = document.querySelector(".header-title");

// productsToggle.addEventListener("click", (event) => {
//   event.preventDefault();

//   // Check if the product review is currently hidden
//   const isHidden =
//     prodctreviewWrap.classList.contains("custome_toggle") ||
//     prodctreviewWrap.classList.contains("remove-fade-products-review");

//   if (isHidden) {
//     prodctreviewWrap.classList.remove(
//       "custome_toggle",
//       "remove-fade-products-review"
//     );
//     navbar.classList.add("hide-main-menu", "sub_menu_active", "align-start");
//     productsMenu.classList.add("active-sub");
//     mainMenu.classList.add("main_menu_toggle");

//     setTimeout(() => {
//       reviewWrap.style.display = "flex";
//       prodctreviewWrap.classList.add("product_review_transition");
//       logoHide.classList.add("hide-logo");
//     }, 100);
//   } else {
//     // If shown, hide the product review
//     prodctreviewWrap.classList.add(
//       "custome_toggle",
//       "remove-fade-products-review"
//     );
//     navbar.classList.remove("hide-main-menu", "sub_menu_active", "align-start");
//     logoHide.classList.remove("hide-logo");
//     mainMenu.classList.remove("main_menu_toggle");
//     reviewWrap.style.display = "none";
//     prodctreviewWrap.classList.remove("product_review_transition");
//   }
// });

goBackBtn.addEventListener("click", (event) => {
  event.preventDefault();
  prodctreviewWrap.classList.add(
    "custome_toggle",
    "remove-fade-products-review"
  );
  navbar.classList.remove("hide-main-menu", "sub_menu_active", "align-start");
  productsMenu.classList.remove("active-sub");
  // logoHide.classList.remove("hide-logo");
  mainMenu.classList.remove("main_menu_toggle");
  reviewWrap.style.display = "none";
});

console.log(getPagePath());

//scroll trigger
let lastScrollPosition = 0;
const header = document.querySelector(".site-header");

const validPaths = [
  "/",
  "/pages/cocktails",
  "/pages/recipes",
  "/pages/valentines-landing",
];
if (validPaths.includes(currentPath)) {
  headerTitle.style.color = "white";
  cartCount.style.color = "white";
  carttextMobile.style.color = "white";
  cartIcon.classList.add("menu-bottle-white");
  menuBottle.classList.add("menu-bottle-white");
  menuText.style.color = "white";
  // cartBorder.style.borderRight = " 1px solid white";
} else {
  headerTitle.style.color = "#2B2B2B";
  cartCount.style.color = "#2B2B2B";
  carttextMobile.style.color = "#2B2B2B";
  menuText.style.color = "#2B2B2B";
}
window.addEventListener("scroll", function () {
  navScroll();
});

const navScroll = () => {
  const currentScrollPosition =
    window.scrollY || document.documentElement.scrollTop;

  // console.log(currentScrollPosition);
  if (currentScrollPosition < lastScrollPosition) {
    header.style.top = "0"; // Show header
    header.classList.add("fixed");
    if (currentScrollPosition > 100) {
      console.log("Add");
      header.classList.add("has-bg");
      if (validPaths.includes(currentPath)) {
        headerTitle.classList.add("colored-title");
        cartCount.classList.add("colored-title");
        carttextMobile.classList.add("colored-title");
        cartIcon.classList.remove("menu-bottle-white");
        menuBottle.classList.remove("menu-bottle-white");
        menuText.classList.add("colored-title");
      }
    }
    // Remove background color if at the top of the page
    if (currentScrollPosition < 100) {
      if (validPaths.includes(currentPath)) {
        if (!navbar.classList.contains("active")) {
          header.classList.remove("has-bg");
          headerTitle.classList.remove("colored-title");
          cartCount.classList.remove("colored-title");
          carttextMobile.classList.remove("colored-title");
          cartIcon.classList.add("menu-bottle-white");
          menuBottle.classList.add("menu-bottle-white");
          menuText.classList.remove("colored-title");
        }
      }
    }
  } else {
    if (!navbar.classList.contains("active") && currentScrollPosition > 100) {
      header.style.top = "-172px";
    } else if (currentScrollPosition >= 0) {
      header.style.top = "0px";
    }
  }

  lastScrollPosition = currentScrollPosition;
};
